import { Input, Table } from 'antd';
import styled from 'styled-components';

export const TableWrapper = styled(Table)`
  overflow: auto;
  .emp-ant-table {
    .emp-ant-table-tbody {
      > tr {
        > td {
          padding: 8px 16px !important;
          // hack to give child divs height 100%
          height: 1px;
          vertical-align: top;
        }
      }
    }
    .cell-link {
      cursor: pointer;
      color: #0046ff;
    }
    .emp-ant-table-thead {
      > tr:first-child {
        > th {
          height: 36px;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          text-align: left;
          padding: 0 8px;
          background-color: #f5f5f5;
        }
      }
    }
  }
`;

export const InputSearchStyled = styled(Input.Search)`
  && .emp-ant-input {
    border: none;
    color: #0046ff;
  }
`;

export const LiveExplorerContainer = styled.div<{ embedded?: boolean }>`
  width: 100%;
  height: 100%;
  min-width: ${(props) => (props.embedded ? null : '1280px')};

  .single-id-selector .emp-ant-select-compact-first-item {
    min-width: 200px;
  }

  .emp-ant-select .emp-ant-select-arrow {
    top: 16px;
  }
`;

export const TimelineToolbarTitle = styled.div`
  max-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100vw - 950px);
`;
